import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '@atlaskit/button';
import { Hide, Show } from '@atlaskit/primitives/responsive';

import { i18n } from './bpqai18n.ts';
import { SHOW_MORE_ELEMENTS } from './bpqaConst.ts';
import {
	Link,
	ButtonText,
	QuickCardContainer,
	QuickCardColumn,
	QuickCardIcon,
} from './bpqaStyled.tsx';
import { QuickActionIcon } from './QuickActionIcon.tsx';

interface ShowMoreElementsLinkProps {
	disabled: boolean;
	handleMoreElementsClick: () => void;
	isActive: boolean;
}

export const ShowMoreElementsLink = ({
	disabled,
	handleMoreElementsClick,
	isActive,
}: ShowMoreElementsLinkProps) => {
	return (
		<>
			<Hide below="xs">
				{/* eslint-disable-next-line @atlassian/a11y/anchor-is-valid */}
				<Link isActive={isActive}>
					<Button
						testId="blank-page-quick-actions-more-elements-link"
						onClick={handleMoreElementsClick}
						isDisabled={disabled}
						spacing="compact"
						shouldFitContainer
					>
						<ButtonText isDisabled={disabled}>
							<FormattedMessage {...i18n.moreElements} />
						</ButtonText>
					</Button>
				</Link>
			</Hide>
			<Show below="xs">
				<QuickCardContainer isDisabled={disabled}>
					<Button
						isSelected={isActive}
						onClick={handleMoreElementsClick}
						isDisabled={disabled}
						spacing="compact"
						iconBefore={
							<QuickCardIcon isDisabled={disabled}>
								<QuickActionIcon quickActionId={SHOW_MORE_ELEMENTS.id} />
							</QuickCardIcon>
						}
					>
						<QuickCardColumn>
							<ButtonText isDisabled={disabled}>
								<FormattedMessage {...i18n.moreElements} />
							</ButtonText>
						</QuickCardColumn>
					</Button>
				</QuickCardContainer>
			</Show>
		</>
	);
};
